import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../../commonComponents/translate';
import SessionProp from '../../propTypes/sessionProp';
import { composeDate, getLink } from '../../../../services/utilityFunctions';
import { SESSION_TYPE } from '../../propTypes/sessionUtils';

function ClassroomInfo({ t, session }) {
  const { classroom, startDate, endDate, host, type } = session;
  const { address, link, notes, placeLocation } = classroom || {};

  const linkSession = link ? getLink(link) : '';

  const notesSession = notes || '';
  const phone = host && host.phone ? host.phone : '';
  const email = host && host.email ? host.email : '';

  const openLink = () => {
    window.open(linkSession, '_blank');
  };

  const { estimatedTime, days, hours, minutes } = composeDate(
    startDate,
    endDate,
  );
  const showEstimation =
    (days > 0 || hours > 0 || minutes > 0) &&
    (type === SESSION_TYPE.CLASSROOM || type === SESSION_TYPE.WEBINAR);
  return (
    <div className="session-location">
      <div className={cx('session-info-extra')}>
        <div className="row">
          <div className="col-lg-12">
            {/** ESTIMATED DURATION */}
            {showEstimation && (
              <span className="session-location-item">
                <img
                  src="/images/academy/session/clock-session.svg"
                  alt="clock"
                />
                <span className="session-location-item_title">
                  {t('sessionDetails.location.time')}
                </span>
                <span className="session-location-item_value">
                  {estimatedTime}
                </span>
              </span>
            )}
            {/** LINK */}
            {type === SESSION_TYPE.CLASSROOM && classroom.link && (
              <span className="session-location-item">
                <img src="/images/academy/session/link-session.svg" alt="pin" />
                <span className="session-location-item_title">
                  {t('sessionDetails.location.link')}
                </span>
                <button
                  type="button"
                  onClick={openLink}
                  className="session-location-linkButton"
                >
                  {linkSession}
                </button>
              </span>
            )}
            {/** ADDRESS */}
            {type === SESSION_TYPE.CLASSROOM &&
              (address.address || placeLocation?.length > 0) && (
                <span className="session-location-item">
                  <img
                    src="/images/academy/session/pin-session.svg"
                    alt="pin"
                  />
                  <div className="pin-location-container">
                    {placeLocation && placeLocation.length > 0 && (
                      <div className="location-item">
                        <span className="session-location-item_title">
                          {t('access_session.detail.placeLocation')}
                        </span>
                        <span className="session-location-item_value">
                          {placeLocation}
                        </span>
                      </div>
                    )}
                    {address.address && address.address.length > 0 && (
                      <div className="location-item">
                        <span className="session-location-item_title">
                          {t('sessionDetails.location.address')}
                        </span>
                        <span className="session-location-item_value">
                          {address.address}
                        </span>
                      </div>
                    )}
                  </div>
                </span>
              )}
            {/** CONTACT */}
            {!!(phone || email) && (
              <span className="session-location-item session-location-item-contact">
                <img
                  src="/images/academy/session/phone-session.svg"
                  alt="pin"
                />
                <span className="session-location-item_title">
                  {t('sessionDetails.location.hostContact')}
                </span>
                <span className="session-location-item_value">
                  {`${email ? `${email}\n` : ''}${phone || ''}`}
                </span>
              </span>
            )}
            {/** NOTES */}
            {type === SESSION_TYPE.CLASSROOM && classroom.notes && (
              <div>
                <span className="session-location-item">
                  <img
                    src="/images/academy/session/notes-session.svg"
                    alt="pin"
                  />
                  <span className="session-location-item_title">
                    {t('sessionDetails.location.notes')}
                  </span>
                </span>
                <div className="session-location-notes">{notesSession}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

ClassroomInfo.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.shape(SessionProp.propType).isRequired,
};

export default translate(ClassroomInfo);
